import React, { FC, useState, useEffect, useContext } from 'react'

import _ from 'lodash'
import { isMobile, isTablet } from 'react-device-detect'

import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericColumn from '../../../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'

import { SectionContainer, StarImage, TransformationImageButton, TransformationImageContainer, PlatformImage } from '../../style/LandingStyle'
import platformImage from '../../../../assets/REDESIGN_Assets/Landing/laptop-image.png'



interface PlatformsSectionInterface { }

const PlatformsSection: FC<PlatformsSectionInterface> = ({ }) => {





  return (
    <SectionContainer className={`platforms ${isTablet ? "isTablet" : ""}`} margin={isMobile ? "10% 0 0 0" : "5% 0 0 0"}>
      {/* <GenericRow wrap={isMobile ? 'wrap' : 'unset'}> */}
      <GenericColumn zIndex="1" className={`platforms-section-text`} alignSelf="baseline" width={isMobile ? "100%" : "35%"} margin="5% 0 0 0">
        <GenericTextSpan fWeight="bold" lineHeight="3.5rem" display="block" width="100%" tAlign={isTablet ? "center" : "left"} fSize="3.2rem">
          Jedno konto - 4 platformy
        </GenericTextSpan>

        <GenericTextSpan color={"rgba(255,255,255,0.8)"} lineHeight="1.7rem" display="block" width="100%" tAlign="left" fSize={isMobile ? "1.2rem" : "1.1rem"} margin={"8% 0 0 0"}>
          Posiadając konto masz dostęp do:
          <ol>
            <li>
              aplikacji internetowej MIAZGA
            </li>
            <li>
              aplikacji mobilnych na Android oraz iOS
            </li>
            <li>
              aplikacji mobilnej dla Huawei w AppGallery
            </li>
          </ol>
        </GenericTextSpan>

      </GenericColumn>
      {/* <GenericColumn className="platforms-section-image" width={isMobile ? "100%" : "60%"}> */}
      {/* </GenericColumn> */}
      {/* </GenericRow> */}
      <PlatformImage id="platformImage" className={` ${isTablet ? "isTablet" : ""}`} src={platformImage} />

    </SectionContainer>
  )
}

export default PlatformsSection
